export const imgStyle = () => {
    return {
        overflow: "hidden",
        display: "inherit",
        width: "100%",
        height: "100%",
    };
};
